import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { Specialization, CacheService } from "mapfre-auditlib";
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})

export class SpecializationService {

  className = 'SpecializationService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAllSpecializations(cache = true, cacheKey = "allSpecializations"): Observable<any[]> | any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<Specialization[]>(environment.base_URL + "/types-speciality").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newSpecialization(specializations) {
    return this.http.post(environment.base_URL + "/types-speciality", specializations)
  }

  updateSpecialization(specializations, id) {
    return this.http.put(environment.base_URL + `/types-speciality/${id}`, specializations)
  }
}

